import { JobCompletedEnum, JobStatusEnum, OperationTypeEnum, PlantsEnum, ShiftsEnum, SubPlantCodesEnum, WorkStationTypeEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class ProductionLogData {
    @ApiProperty()
    productionLogId: number;
    @ApiProperty()
    operationType: OperationTypeEnum;
    @ApiProperty()
    lotNumber: string;
    @ApiProperty()
    subLotNumber: string;
    @ApiProperty()
    jobNumber: string
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    saleOrderItemId: number;
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    subPlantId: number;
    // @ApiProperty()
    // subPlantId: SubPlantCodesEnum;
    @ApiProperty()
    workStationType: WorkStationTypeEnum;
    @ApiProperty()
    jobStatus: JobCompletedEnum;
    @ApiProperty()
    assignFreezing: JobCompletedEnum;
    @ApiProperty()
    workStation: number;
    @ApiProperty()
    inputGrade?: number;
    @ApiProperty()
    plannedGrade?: number;
    @ApiProperty()
    actualGrade?: number;
    @ApiProperty()
    inputQuantity: number;
    @ApiProperty()
    plannedOutputQuantity?: number;
    @ApiProperty()
    actualOutputQuantity?: number;
    @ApiProperty()
    inputBoxes: number;
    @ApiProperty()
    outputBoxes: number;
    @ApiProperty()
    assignedUser: string
    @ApiProperty()
    assignedTime: string
    @ApiProperty()
    shift: ShiftsEnum;
    @ApiProperty()
    isReceived: JobCompletedEnum;
    @ApiProperty()
    createdUser: string | null;
    @ApiProperty()
    updatedUser: string | null;
}